import React from "react";

export default function HandshakeIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4 14H9.73006C11.1835 14 12.5774 13.2806 13.6051 12.0001C15.0729 10.1713 17.2439 9.53272 19.2131 10.3506L22 11.508M4 31.9336H7.24136C9.56034 31.9336 10.7198 31.9336 11.8162 32.2426C11.8695 32.2576 11.9227 32.2732 11.9756 32.2892C13.0652 32.6202 14.0299 33.2418 15.9594 34.4854C19.7357 36.9192 21.624 38.1362 23.6814 37.988C23.7784 37.981 23.8752 37.9716 23.9718 37.9602C26.0192 37.7154 27.6238 36.1642 30.8332 33.0616L34 30'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
      />
      <path
        d='M44 14.4677H38.9664C36.8348 14.4677 35.3298 13.3094 33.8006 11.7652C32.8102 10.7649 31.5462 10.1754 30.2176 10.0943C28.732 10.0035 27.0106 9.87571 25.568 10.272C23.9622 10.7131 22.902 11.9213 21.7804 13.1839L18.8862 16.4422C17.7046 17.7724 17.7046 19.9291 18.8862 21.2594C19.906 22.4074 21.5038 22.5856 22.7038 21.6848C23.5674 21.0368 24.5486 19.9901 25.5662 19.6605C26.7114 19.2895 27.4218 20.123 28.0708 20.9998L32.7112 27.2688C34.4334 29.5952 35.2944 30.7586 36.4716 31.3792C37.6488 32 38.9938 32 41.684 32H44'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </svg>
  );
}
